export const dataFetchReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_INIT':
        return {
            ...state,
            isLoading: true
        };
        case 'FETCH_SUCCESS':
        return {
            isLoading: false,
            isError: false,
            data: action.payload,
        };
        case 'FETCH_FAILURE':
        return {
            isLoading: false,
            isError: true,
            data: null
        };
        default:
        throw new Error();
    }
};
